import GiftVoucherIcon from '@/icons/gift-voucher-icon';

export default function InvalidGiftCard() {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="flex flex-col items-center">
        <GiftVoucherIcon className="size-40" />
        <div>
          <h3 className="text-lg font-semibold text-gray-900 text-center">
            Gift Card Not Found
          </h3>
          <p className="text-sm text-center">
            The gift card you're looking for could not be found. Please check
            the code and try again.
          </p>
        </div>
      </div>
    </div>
  );
}
